import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { TAG_MULTIPATH_CTA } from '../../analytics/analytics.tagids.constants'
import { selectMapTooSlowTooltip } from '../../../store/ui/ui.selectors'
import { hideUiMapTooSlowTooltip } from '../../../store/ui/uiSlice'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import { withOnlyGE } from '../../Device'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import cross from '../../genericComponents/assets/cross.svg'
import T from '../../i18n/T'
import SVGIcon from '../../svg/SVGIcon'
import { withEverySelectorTruthy } from '../../utils/react-redux'
import useEventCallback from '../../utils/useEventCallback'
import s from './MapTooSlowTooltip.less'

const MapTooSlowTooltip = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(true)

  const closeTooltip = useEventCallback(() => {
    dispatch(hideUiMapTooSlowTooltip())
  }, [])

  const configureAndSendTag = useConfigureAndSendTag()

  useEffect(() => {
    configureAndSendTag({
      type: TAG_MULTIPATH_CTA,
      tagInfo: { tag: PUB_TAG.PUB_MAP_POP_IN_MAP_TOO_SLOW },
      isImpression: true
    })
    setTimeout(() => setVisible(false), 5000)
  }, [])

  return (
    <div className={classNames(s.root, !visible ? s.hide : '')} onClick={closeTooltip}>
      <div className={s.content}>
        <p>
          <T id={'map.tools.tooSlowToolip.title'} />
        </p>
        <p>
          <T id={'map.tools.tooSlowToolip.text'} />
        </p>
      </div>
      <div className={s.closeButton}>
        <SVGIcon url={cross} />
      </div>
    </div>
  )
}
export default withOnlyGE(withEverySelectorTruthy(selectMapTooSlowTooltip)(MapTooSlowTooltip))
